<template>
    <div class="Part Chart Overview" v-if="viewData.config.settings?.target">
        <ul class="block-grid one-up">
            <li v-for="item in items">
                <WorkflowchartItem :item="item"/>
            </li>
        </ul>
    </div>
</template>

<script>
import {defineComponent, inject, computed, ref } from "vue";
import {useRoute} from "vue-router";

import Icon from "components/icon";
import trans from "helpers/_translation";

import WorkflowchartItem from "view/dashboard/includes/workflowchart-item";

export default defineComponent({
    name: "part",
    components: {
        Icon,
        WorkflowchartItem
    },
    setup() {
        const route = useRoute();
        const viewData = inject("viewData");

        const items = computed(() => {
            return viewData.config.settings.target?.chart_items.map(item => {
                const result = JSON.parse(JSON.stringify(item));
                if (typeof result.columns === "string") {
                    result.columns = viewData.config.settings.target?.[result.columns] ?? undefined;
                }
                return result;
            });
        });

        return {
            trans,
            route,
            viewData,
            items
        }
    }
});
</script>
<script setup>
</script>